export default __webpack_public_path__ + "static/media/splash-background.140f191f.jpg";